import { SkeletonBox, SkeletonText, SkeletonCircle } from '../primitives';
import '../primitives/Skeletons.css';

const ChatLayoutSkeleton = () => {
  return (
    <div className="skeleton-chat" aria-hidden="true">
      {/* Left panel - PDF viewer */}
      <div className="skeleton-chat__left">
        <div className="skeleton-chat__toolbar">
          <SkeletonCircle size={32} />
          <SkeletonText widths={['150px']} lineHeight="16px" />
          <div style={{ flex: 1 }} />
          <SkeletonBox width={80} height={32} borderRadius="var(--radius-sm)" />
          <SkeletonBox width={80} height={32} borderRadius="var(--radius-sm)" />
        </div>
        <SkeletonBox className="skeleton-chat__document" height="auto" style={{ flex: 1 }} />
      </div>

      {/* Right panel - Tabs and content */}
      <div className="skeleton-chat__right">
        <div className="skeleton-chat__tabs">
          {['Chat', 'Questions', 'Flashcards', 'Hard', 'Mind Map', 'Podcast'].map((tab) => (
            <SkeletonBox
              key={tab}
              className="skeleton-chat__tab"
              width={70}
              height={32}
              borderRadius="var(--radius-sm)"
            />
          ))}
        </div>
        <div className="skeleton-chat__content">
          {/* Chat messages placeholder */}
          <div style={{ display: 'flex', gap: 'var(--space-sm)', alignItems: 'flex-start' }}>
            <SkeletonCircle size={32} />
            <div style={{ flex: 1 }}>
              <SkeletonText lines={2} widths={['90%', '70%']} lineHeight="16px" />
            </div>
          </div>
          <div style={{ display: 'flex', gap: 'var(--space-sm)', alignItems: 'flex-start', justifyContent: 'flex-end' }}>
            <div style={{ maxWidth: '70%' }}>
              <SkeletonBox height={60} borderRadius="var(--radius-md)" />
            </div>
          </div>
          <div style={{ display: 'flex', gap: 'var(--space-sm)', alignItems: 'flex-start' }}>
            <SkeletonCircle size={32} />
            <div style={{ flex: 1 }}>
              <SkeletonText lines={3} widths={['95%', '85%', '60%']} lineHeight="16px" />
            </div>
          </div>
          {/* Input area */}
          <div style={{ marginTop: 'auto' }}>
            <SkeletonBox height={48} borderRadius="var(--radius-lg)" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatLayoutSkeleton;
